@if (canShow) {
<ng-container *ngComponentOutlet="
    toolsOutlet.component;
    inputs: $any(toolsOutlet.inputs);
    " />
<div class="wrap">
    <div cy-searchProductsListing
         cy-listingProductsGrid>
        <!-- empty list -->
        @if (ready && !models.length) {
        <p class="p-a center"
           cy-searchNoResults>{{'There are no results matching your selection.' | translate}}</p>
        }
        @if(models.length > 0) {
        <!-- product list -->
        <div [ngClass]="['listing-size-' + gridSize]"
             [grid]="gridSize"
             [gridRowGap]="[7, 10, 20, 20][client.sizeId]">

            @for (model of models; track model.id; let i = $index) {
            <product [ngClass]="['colspan-' + colspan(model), 'rowspan-' + rowspan(model)]"
                     [modelId]="model.id"
                     [gridColumn]="colspan(model)"
                     [gridRowSpan]="rowspan(model)"
                     [acItem]="toAcItem(model)"
                     [canShowTieredPrice]="canShowTieredPrice"
                     [showQuickBuyAnimation]="true"
                     [gtmImpressionTrack]="{productId: toProductId(model), position: i+1, list: context === 'search' ? 'Search results' : '', numberOfResults: getTotal}"
                     [gtmTrackProductClick]="{productId: toProductId(model), position: i+1, list: context === 'search' ? 'Search results' : ''}"
                     [acClickCode]="clickCode"
                     [listing]="listing"
                     [iCmsLink]="{type: 'product', model: model, listing: listing}"
                     [searchTerm]="context === 'search' ? searchTerm : ''"
                     style="visibility:hidden;"
                     cy-listingProduct>
            </product>
            }
        </div>
        } @else if (!ready) {
        <div class="center">
            <i class="icon-loading"></i>
        </div>
        }
    </div>
    <!-- view more and qty viewed - no point showing below at least few elements -->
    <ng-container *afterContentInit>
        <div class="m-t-8 p-t-10 center">
            @if (!hasMore) {
            <div class="flex flex-justify-center">
                <span class="_products-loaded-icon fs-11 col-6 icon-tick m-b"></span>
            </div>
            }
            <!-- number of viewed elements  -->
            <p class="p1 col-1">{{ 'You’ve viewed % of % products' | translate : visibleQty : getTotal }}</p>
            <!-- view more button -->
            <button [disabled]="!hasMore"
                    class="m-t-5 button"
                    type="button"
                    (click)="increaseLimit()"
                    [attr.aria-label]="'Load more' | translate">{{'Load more' | translate}}</button>
        </div>
    </ng-container>
</div>
}